import { render, staticRenderFns } from "./destinatario.vue?vue&type=template&id=29b24fe6"
import script from "./destinatario.ts?vue&type=script&lang=js&external"
export * from "./destinatario.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b24fe6')) {
      api.createRecord('29b24fe6', component.options)
    } else {
      api.reload('29b24fe6', component.options)
    }
    module.hot.accept("./destinatario.vue?vue&type=template&id=29b24fe6", function () {
      api.rerender('29b24fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/destinatario.vue"
export default component.exports